// AUTO-GENERATED FROM neighborhoodMap.js

export interface AreaInfo {
  areaSlug: string;
  areaName: string;
  county: string;
}

const allAreas: AreaInfo[] = [
  {
    "areaSlug": "aghowle",
    "areaName": "Aghowle",
    "county": "Wicklow"
  },
  {
    "areaSlug": "airport",
    "areaName": "Airport",
    "county": "Fingal"
  },
  {
    "areaSlug": "altidore",
    "areaName": "Altidore",
    "county": "Wicklow"
  },
  {
    "areaSlug": "ardagh",
    "areaName": "Ardagh",
    "county": "Kerry"
  },
  {
    "areaSlug": "ardbraccan",
    "areaName": "Ardbraccan",
    "county": "Meath"
  },
  {
    "areaSlug": "ardcath",
    "areaName": "Ardcath",
    "county": "Meath"
  },
  {
    "areaSlug": "ardmulchan",
    "areaName": "Ardmulchan",
    "county": "Meath"
  },
  {
    "areaSlug": "ardnamullan",
    "areaName": "Ardnamullan",
    "county": "Meath"
  },
  {
    "areaSlug": "arklow",
    "areaName": "Arklow",
    "county": "Wicklow"
  },
  {
    "areaSlug": "arklow-no.",
    "areaName": "Arklow No.",
    "county": "Wicklow"
  },
  {
    "areaSlug": "arran-quay",
    "areaName": "Arran Quay",
    "county": "Dublin City"
  },
  {
    "areaSlug": "ashtown",
    "areaName": "Ashtown",
    "county": "Dublin City"
  },
  {
    "areaSlug": "athboy",
    "areaName": "Athboy",
    "county": "Meath"
  },
  {
    "areaSlug": "athy",
    "areaName": "Athy",
    "county": "Kildare"
  },
  {
    "areaSlug": "athy-east",
    "areaName": "Athy East",
    "county": "Kildare"
  },
  {
    "areaSlug": "athy-west",
    "areaName": "Athy West",
    "county": "Kildare"
  },
  {
    "areaSlug": "aughrim",
    "areaName": "Aughrim",
    "county": "Galway"
  },
  {
    "areaSlug": "ayrfield",
    "areaName": "Ayrfield",
    "county": "Dublin City"
  },
  {
    "areaSlug": "balbriggan",
    "areaName": "Balbriggan",
    "county": "Fingal"
  },
  {
    "areaSlug": "baldoyle",
    "areaName": "Baldoyle",
    "county": "Fingal"
  },
  {
    "areaSlug": "balgriffin",
    "areaName": "Balgriffin",
    "county": "Fingal"
  },
  {
    "areaSlug": "ballaghmoon",
    "areaName": "Ballaghmoon",
    "county": "Kildare"
  },
  {
    "areaSlug": "ballinaclash",
    "areaName": "Ballinaclash",
    "county": "Wicklow"
  },
  {
    "areaSlug": "ballinacor",
    "areaName": "Ballinacor",
    "county": "Wicklow"
  },
  {
    "areaSlug": "ballinascorney",
    "areaName": "Ballinascorney",
    "county": "South Dublin"
  },
  {
    "areaSlug": "ballincollig",
    "areaName": "Ballincollig",
    "county": "Cork City"
  },
  {
    "areaSlug": "ballinderry",
    "areaName": "Ballinderry",
    "county": "Galway"
  },
  {
    "areaSlug": "ballingate",
    "areaName": "Ballingate",
    "county": "Wicklow"
  },
  {
    "areaSlug": "ballinglen",
    "areaName": "Ballinglen",
    "county": "Wicklow"
  },
  {
    "areaSlug": "ballinguile",
    "areaName": "Ballinguile",
    "county": "Wicklow"
  },
  {
    "areaSlug": "ballinlough",
    "areaName": "Ballinlough",
    "county": "Westmeath"
  },
  {
    "areaSlug": "ballitore",
    "areaName": "Ballitore",
    "county": "Kildare"
  },
  {
    "areaSlug": "ballyarthur",
    "areaName": "Ballyarthur",
    "county": "Cork"
  },
  {
    "areaSlug": "ballybaan",
    "areaName": "Ballybaan",
    "county": "Galway City"
  },
  {
    "areaSlug": "ballybeg",
    "areaName": "Ballybeg",
    "county": "Wicklow"
  },
  {
    "areaSlug": "ballyboden",
    "areaName": "Ballyboden",
    "county": "South Dublin"
  },
  {
    "areaSlug": "ballyboggan",
    "areaName": "Ballyboggan",
    "county": "Meath"
  },
  {
    "areaSlug": "ballyboghil",
    "areaName": "Ballyboghil",
    "county": "Fingal"
  },
  {
    "areaSlug": "ballybough",
    "areaName": "Ballybough",
    "county": "Dublin City"
  },
  {
    "areaSlug": "ballybrackan",
    "areaName": "Ballybrackan",
    "county": "Kildare"
  },
  {
    "areaSlug": "ballybrit",
    "areaName": "Ballybrit",
    "county": "Galway City"
  },
  {
    "areaSlug": "ballyconnell",
    "areaName": "Ballyconnell",
    "county": "Cavan"
  },
  {
    "areaSlug": "ballycullen",
    "areaName": "Ballycullen",
    "county": "Wicklow"
  },
  {
    "areaSlug": "ballygall",
    "areaName": "Ballygall",
    "county": "Dublin City"
  },
  {
    "areaSlug": "ballygarvan/lehenagh",
    "areaName": "Ballygarvan/lehenagh",
    "county": "Cork City"
  },
  {
    "areaSlug": "ballymore-eustace",
    "areaName": "Ballymore Eustace",
    "county": "Kildare"
  },
  {
    "areaSlug": "ballymun",
    "areaName": "Ballymun",
    "county": "Dublin City"
  },
  {
    "areaSlug": "ballynadrumny",
    "areaName": "Ballynadrumny",
    "county": "Kildare"
  },
  {
    "areaSlug": "ballyphehane",
    "areaName": "Ballyphehane",
    "county": "Cork City"
  },
  {
    "areaSlug": "ballysax",
    "areaName": "Ballysax",
    "county": "Kildare"
  },
  {
    "areaSlug": "ballyshannon",
    "areaName": "Ballyshannon",
    "county": "Kildare"
  },
  {
    "areaSlug": "balraheen",
    "areaName": "Balraheen",
    "county": "Kildare"
  },
  {
    "areaSlug": "balrathboyne",
    "areaName": "Balrathboyne",
    "county": "Meath"
  },
  {
    "areaSlug": "balscadden",
    "areaName": "Balscadden",
    "county": "Fingal"
  },
  {
    "areaSlug": "baltinglass",
    "areaName": "Baltinglass",
    "county": "Wicklow"
  },
  {
    "areaSlug": "barna",
    "areaName": "Barna",
    "county": "Galway City"
  },
  {
    "areaSlug": "beaumont",
    "areaName": "Beaumont",
    "county": "Dublin City"
  },
  {
    "areaSlug": "bective",
    "areaName": "Bective",
    "county": "Meath"
  },
  {
    "areaSlug": "belan",
    "areaName": "Belan",
    "county": "Kildare"
  },
  {
    "areaSlug": "bert",
    "areaName": "Bert",
    "county": "Kildare"
  },
  {
    "areaSlug": "bishopstown",
    "areaName": "Bishopstown",
    "county": "Cork City"
  },
  {
    "areaSlug": "blackpool",
    "areaName": "Blackpool",
    "county": "Cork City"
  },
  {
    "areaSlug": "blanchardstown-abbotstown",
    "areaName": "Blanchardstown Abbotstown",
    "county": "Fingal"
  },
  {
    "areaSlug": "blanchardstown-blakestown",
    "areaName": "Blanchardstown Blakestown",
    "county": "Fingal"
  },
  {
    "areaSlug": "blanchardstown-coolmine",
    "areaName": "Blanchardstown Coolmine",
    "county": "Fingal"
  },
  {
    "areaSlug": "blanchardstown-corduff",
    "areaName": "Blanchardstown Corduff",
    "county": "Fingal"
  },
  {
    "areaSlug": "blanchardstown-delwood",
    "areaName": "Blanchardstown Delwood",
    "county": "Fingal"
  },
  {
    "areaSlug": "blanchardstown-mulhuddart",
    "areaName": "Blanchardstown Mulhuddart",
    "county": "Fingal"
  },
  {
    "areaSlug": "blanchardstown-roselawn",
    "areaName": "Blanchardstown Roselawn",
    "county": "Fingal"
  },
  {
    "areaSlug": "blanchardstown-tyrrelstown",
    "areaName": "Blanchardstown Tyrrelstown",
    "county": "Fingal"
  },
  {
    "areaSlug": "blarney",
    "areaName": "Blarney",
    "county": "Cork City"
  },
  {
    "areaSlug": "blessington",
    "areaName": "Blessington",
    "county": "Wicklow"
  },
  {
    "areaSlug": "bodenstown",
    "areaName": "Bodenstown",
    "county": "Kildare"
  },
  {
    "areaSlug": "boherboy",
    "areaName": "Boherboy",
    "county": "Cork"
  },
  {
    "areaSlug": "bohernabreena",
    "areaName": "Bohernabreena",
    "county": "South Dublin"
  },
  {
    "areaSlug": "botanic",
    "areaName": "Botanic",
    "county": "Dublin City"
  },
  {
    "areaSlug": "bray-no.",
    "areaName": "Bray No.",
    "county": "Wicklow"
  },
  {
    "areaSlug": "brockagh",
    "areaName": "Brockagh",
    "county": "Wicklow"
  },
  {
    "areaSlug": "browningstown",
    "areaName": "Browningstown",
    "county": "Cork City"
  },
  {
    "areaSlug": "burgage",
    "areaName": "Burgage",
    "county": "Wicklow"
  },
  {
    "areaSlug": "burry",
    "areaName": "Burry",
    "county": "Meath"
  },
  {
    "areaSlug": "burtown",
    "areaName": "Burtown",
    "county": "Kildare"
  },
  {
    "areaSlug": "cabra",
    "areaName": "Cabra",
    "county": "Dublin City"
  },
  {
    "areaSlug": "cadamstown",
    "areaName": "Cadamstown",
    "county": "Kildare"
  },
  {
    "areaSlug": "caherlag",
    "areaName": "Caherlag",
    "county": "Cork City"
  },
  {
    "areaSlug": "calary",
    "areaName": "Calary",
    "county": "Wicklow"
  },
  {
    "areaSlug": "carbury",
    "areaName": "Carbury",
    "county": "Kildare"
  },
  {
    "areaSlug": "carna",
    "areaName": "Carna",
    "county": "Dublin City"
  },
  {
    "areaSlug": "carnalway",
    "areaName": "Carnalway",
    "county": "Kildare"
  },
  {
    "areaSlug": "carnew",
    "areaName": "Carnew",
    "county": "Wicklow"
  },
  {
    "areaSlug": "carragh",
    "areaName": "Carragh",
    "county": "Kildare"
  },
  {
    "areaSlug": "carrick",
    "areaName": "Carrick",
    "county": "Kildare"
  },
  {
    "areaSlug": "carrickleck",
    "areaName": "Carrickleck",
    "county": "Meath"
  },
  {
    "areaSlug": "carrigaline/monkstown-rural/douglas",
    "areaName": "Carrigaline/monkstown Rural/douglas",
    "county": "Cork City"
  },
  {
    "areaSlug": "carrigeen",
    "areaName": "Carrigeen",
    "county": "Kildare"
  },
  {
    "areaSlug": "carrigrohanebeg",
    "areaName": "Carrigrohanebeg",
    "county": "Cork City"
  },
  {
    "areaSlug": "castledermot",
    "areaName": "Castledermot",
    "county": "Kildare"
  },
  {
    "areaSlug": "castlegar",
    "areaName": "Castlegar",
    "county": "Galway City"
  },
  {
    "areaSlug": "castlejordan",
    "areaName": "Castlejordan",
    "county": "Meath"
  },
  {
    "areaSlug": "castlekeeran",
    "areaName": "Castlekeeran",
    "county": "Meath"
  },
  {
    "areaSlug": "castleknock-knockmaroon",
    "areaName": "Castleknock Knockmaroon",
    "county": "Fingal"
  },
  {
    "areaSlug": "castleknock-park",
    "areaName": "Castleknock Park",
    "county": "Fingal"
  },
  {
    "areaSlug": "castlerickard",
    "areaName": "Castlerickard",
    "county": "Meath"
  },
  {
    "areaSlug": "castletown",
    "areaName": "Castletown",
    "county": "Clare"
  },
  {
    "areaSlug": "ceanannas-mór",
    "areaName": "Ceanannas Mór",
    "county": "Meath"
  },
  {
    "areaSlug": "celbridge",
    "areaName": "Celbridge",
    "county": "Kildare"
  },
  {
    "areaSlug": "centre",
    "areaName": "Centre",
    "county": "Cork City"
  },
  {
    "areaSlug": "chapelizod",
    "areaName": "Chapelizod",
    "county": "Dublin City"
  },
  {
    "areaSlug": "cherry-orchard",
    "areaName": "Cherry Orchard",
    "county": "Dublin City"
  },
  {
    "areaSlug": "churchfield",
    "areaName": "Churchfield",
    "county": "Cork City"
  },
  {
    "areaSlug": "churchtown",
    "areaName": "Churchtown",
    "county": "Kerry"
  },
  {
    "areaSlug": "city-hall",
    "areaName": "City Hall",
    "county": "Cork City"
  },
  {
    "areaSlug": "claddagh",
    "areaName": "Claddagh",
    "county": "Galway City"
  },
  {
    "areaSlug": "clane",
    "areaName": "Clane",
    "county": "Kildare"
  },
  {
    "areaSlug": "cloghbrack",
    "areaName": "Cloghbrack",
    "county": "Meath"
  },
  {
    "areaSlug": "cloncurry",
    "areaName": "Cloncurry",
    "county": "Kildare"
  },
  {
    "areaSlug": "clondalkin-ballymount",
    "areaName": "Clondalkin Ballymount",
    "county": "South Dublin"
  },
  {
    "areaSlug": "clondalkin-cappaghmore",
    "areaName": "Clondalkin Cappaghmore",
    "county": "South Dublin"
  },
  {
    "areaSlug": "clondalkin-dunawley",
    "areaName": "Clondalkin Dunawley",
    "county": "South Dublin"
  },
  {
    "areaSlug": "clondalkin-monastery",
    "areaName": "Clondalkin Monastery",
    "county": "South Dublin"
  },
  {
    "areaSlug": "clondalkin-moorfield",
    "areaName": "Clondalkin Moorfield",
    "county": "South Dublin"
  },
  {
    "areaSlug": "clondalkin-rowlagh",
    "areaName": "Clondalkin Rowlagh",
    "county": "South Dublin"
  },
  {
    "areaSlug": "clondalkin-village",
    "areaName": "Clondalkin Village",
    "county": "South Dublin"
  },
  {
    "areaSlug": "clonmacduff",
    "areaName": "Clonmacduff",
    "county": "Meath"
  },
  {
    "areaSlug": "clonmethan",
    "areaName": "Clonmethan",
    "county": "Fingal"
  },
  {
    "areaSlug": "clontarf",
    "areaName": "Clontarf",
    "county": "Dublin City"
  },
  {
    "areaSlug": "commons",
    "areaName": "Commons",
    "county": "Cork City"
  },
  {
    "areaSlug": "coolattin",
    "areaName": "Coolattin",
    "county": "Wicklow"
  },
  {
    "areaSlug": "coolballintaggart",
    "areaName": "Coolballintaggart",
    "county": "Wicklow"
  },
  {
    "areaSlug": "coolboy",
    "areaName": "Coolboy",
    "county": "Wicklow"
  },
  {
    "areaSlug": "cronebane",
    "areaName": "Cronebane",
    "county": "Wicklow"
  },
  {
    "areaSlug": "cronelea",
    "areaName": "Cronelea",
    "county": "Wicklow"
  },
  {
    "areaSlug": "crossakeel",
    "areaName": "Crossakeel",
    "county": "Meath"
  },
  {
    "areaSlug": "crosskeys",
    "areaName": "Crosskeys",
    "county": "Cavan"
  },
  {
    "areaSlug": "cruicetown",
    "areaName": "Cruicetown",
    "county": "Meath"
  },
  {
    "areaSlug": "crumlin",
    "areaName": "Crumlin",
    "county": "Dublin City"
  },
  {
    "areaSlug": "culmullin",
    "areaName": "Culmullin",
    "county": "Meath"
  },
  {
    "areaSlug": "dangan",
    "areaName": "Dangan",
    "county": "Galway City"
  },
  {
    "areaSlug": "decies",
    "areaName": "Decies",
    "county": "Dublin City"
  },
  {
    "areaSlug": "delgany",
    "areaName": "Delgany",
    "county": "Wicklow"
  },
  {
    "areaSlug": "donabate",
    "areaName": "Donabate",
    "county": "Fingal"
  },
  {
    "areaSlug": "donadea",
    "areaName": "Donadea",
    "county": "Kildare"
  },
  {
    "areaSlug": "donaghcumper",
    "areaName": "Donaghcumper",
    "county": "Kildare"
  },
  {
    "areaSlug": "donaghmore",
    "areaName": "Donaghmore",
    "county": "Wicklow"
  },
  {
    "areaSlug": "donaghpatrick",
    "areaName": "Donaghpatrick",
    "county": "Galway"
  },
  {
    "areaSlug": "donard",
    "areaName": "Donard",
    "county": "Wicklow"
  },
  {
    "areaSlug": "donore",
    "areaName": "Donore",
    "county": "Kildare"
  },
  {
    "areaSlug": "douglas/lehenagh",
    "areaName": "Douglas/lehenagh",
    "county": "Cork City"
  },
  {
    "areaSlug": "downings",
    "areaName": "Downings",
    "county": "Kildare"
  },
  {
    "areaSlug": "drehid",
    "areaName": "Drehid",
    "county": "Kildare"
  },
  {
    "areaSlug": "droichead-nua-(newbridge)",
    "areaName": "Droichead Nua (newbridge)",
    "county": "Kildare"
  },
  {
    "areaSlug": "drumcondra",
    "areaName": "Drumcondra",
    "county": "Meath"
  },
  {
    "areaSlug": "drumfinn",
    "areaName": "Drumfinn",
    "county": "Dublin City"
  },
  {
    "areaSlug": "dubber",
    "areaName": "Dubber",
    "county": "Fingal"
  },
  {
    "areaSlug": "duleek",
    "areaName": "Duleek",
    "county": "Meath"
  },
  {
    "areaSlug": "dunboyne",
    "areaName": "Dunboyne",
    "county": "Meath"
  },
  {
    "areaSlug": "dunfierth",
    "areaName": "Dunfierth",
    "county": "Kildare"
  },
  {
    "areaSlug": "dunganstown",
    "areaName": "Dunganstown",
    "county": "Wicklow"
  },
  {
    "areaSlug": "dunlavin",
    "areaName": "Dunlavin",
    "county": "Wicklow"
  },
  {
    "areaSlug": "dunmanoge",
    "areaName": "Dunmanoge",
    "county": "Kildare"
  },
  {
    "areaSlug": "dunmurry",
    "areaName": "Dunmurry",
    "county": "Kildare"
  },
  {
    "areaSlug": "dunshaughlin",
    "areaName": "Dunshaughlin",
    "county": "Meath"
  },
  {
    "areaSlug": "eadestown",
    "areaName": "Eadestown",
    "county": "Wicklow"
  },
  {
    "areaSlug": "edenmore",
    "areaName": "Edenmore",
    "county": "Dublin City"
  },
  {
    "areaSlug": "edmondstown",
    "areaName": "Edmondstown",
    "county": "South Dublin"
  },
  {
    "areaSlug": "ennereilly",
    "areaName": "Ennereilly",
    "county": "Wicklow"
  },
  {
    "areaSlug": "enniskerry",
    "areaName": "Enniskerry",
    "county": "Wicklow"
  },
  {
    "areaSlug": "evergreen",
    "areaName": "Evergreen",
    "county": "Cork City"
  },
  {
    "areaSlug": "eyre-square",
    "areaName": "Eyre Square",
    "county": "Galway City"
  },
  {
    "areaSlug": "fair-hill",
    "areaName": "Fair Hill",
    "county": "Cork City"
  },
  {
    "areaSlug": "farranferris",
    "areaName": "Farranferris",
    "county": "Cork City"
  },
  {
    "areaSlug": "feighcullen",
    "areaName": "Feighcullen",
    "county": "Kildare"
  },
  {
    "areaSlug": "finglas",
    "areaName": "Finglas",
    "county": "Dublin City"
  },
  {
    "areaSlug": "firhouse-ballycullen",
    "areaName": "Firhouse Ballycullen",
    "county": "South Dublin"
  },
  {
    "areaSlug": "firhouse-knocklyon",
    "areaName": "Firhouse Knocklyon",
    "county": "South Dublin"
  },
  {
    "areaSlug": "firhouse-village",
    "areaName": "Firhouse Village",
    "county": "South Dublin"
  },
  {
    "areaSlug": "fontstown",
    "areaName": "Fontstown",
    "county": "Kildare"
  },
  {
    "areaSlug": "gallow",
    "areaName": "Gallow",
    "county": "Meath"
  },
  {
    "areaSlug": "galtrim",
    "areaName": "Galtrim",
    "county": "Meath"
  },
  {
    "areaSlug": "garristown",
    "areaName": "Garristown",
    "county": "Fingal"
  },
  {
    "areaSlug": "gillabbey",
    "areaName": "Gillabbey",
    "county": "Cork City"
  },
  {
    "areaSlug": "gilltown",
    "areaName": "Gilltown",
    "county": "Kildare"
  },
  {
    "areaSlug": "girley",
    "areaName": "Girley",
    "county": "Meath"
  },
  {
    "areaSlug": "glasheen",
    "areaName": "Glasheen",
    "county": "Cork City"
  },
  {
    "areaSlug": "glendalough",
    "areaName": "Glendalough",
    "county": "Wicklow"
  },
  {
    "areaSlug": "glenealy",
    "areaName": "Glenealy",
    "county": "Wicklow"
  },
  {
    "areaSlug": "grace-park",
    "areaName": "Grace Park",
    "county": "Dublin City"
  },
  {
    "areaSlug": "graney",
    "areaName": "Graney",
    "county": "Kildare"
  },
  {
    "areaSlug": "grange",
    "areaName": "Grange",
    "county": "Dublin City"
  },
  {
    "areaSlug": "grangegeeth",
    "areaName": "Grangegeeth",
    "county": "Meath"
  },
  {
    "areaSlug": "grangemellon",
    "areaName": "Grangemellon",
    "county": "Kildare"
  },
  {
    "areaSlug": "greenmount",
    "areaName": "Greenmount",
    "county": "Cork City"
  },
  {
    "areaSlug": "grennanstown",
    "areaName": "Grennanstown",
    "county": "Meath"
  },
  {
    "areaSlug": "greystones",
    "areaName": "Greystones",
    "county": "Wicklow"
  },
  {
    "areaSlug": "gurranebraher",
    "areaName": "Gurranebraher",
    "county": "Cork City"
  },
  {
    "areaSlug": "harmonstown",
    "areaName": "Harmonstown",
    "county": "Dublin City"
  },
  {
    "areaSlug": "harristown",
    "areaName": "Harristown",
    "county": "Kildare"
  },
  {
    "areaSlug": "hartstown",
    "areaName": "Hartstown",
    "county": "Wicklow"
  },
  {
    "areaSlug": "hill-of-down",
    "areaName": "Hill Of Down",
    "county": "Meath"
  },
  {
    "areaSlug": "hollywood",
    "areaName": "Hollywood",
    "county": "Wicklow"
  },
  {
    "areaSlug": "holmpatrick",
    "areaName": "Holmpatrick",
    "county": "Fingal"
  },
  {
    "areaSlug": "howth",
    "areaName": "Howth",
    "county": "Fingal"
  },
  {
    "areaSlug": "humewood",
    "areaName": "Humewood",
    "county": "Wicklow"
  },
  {
    "areaSlug": "imael",
    "areaName": "Imael",
    "county": "Wicklow"
  },
  {
    "areaSlug": "inchaquire",
    "areaName": "Inchaquire",
    "county": "Kildare"
  },
  {
    "areaSlug": "inchicore",
    "areaName": "Inchicore",
    "county": "Dublin City"
  },
  {
    "areaSlug": "inishkenny",
    "areaName": "Inishkenny",
    "county": "Cork City"
  },
  {
    "areaSlug": "innfield",
    "areaName": "Innfield",
    "county": "Meath"
  },
  {
    "areaSlug": "inns-quay",
    "areaName": "Inns Quay",
    "county": "Dublin City"
  },
  {
    "areaSlug": "johnstown",
    "areaName": "Johnstown",
    "county": "Kilkenny"
  },
  {
    "areaSlug": "julianstown",
    "areaName": "Julianstown",
    "county": "Meath"
  },
  {
    "areaSlug": "kentstown",
    "areaName": "Kentstown",
    "county": "Meath"
  },
  {
    "areaSlug": "kilballyowen",
    "areaName": "Kilballyowen",
    "county": "Clare"
  },
  {
    "areaSlug": "kilberry",
    "areaName": "Kilberry",
    "county": "Kildare"
  },
  {
    "areaSlug": "kilbrew",
    "areaName": "Kilbrew",
    "county": "Meath"
  },
  {
    "areaSlug": "kilbride",
    "areaName": "Kilbride",
    "county": "Kilkenny"
  },
  {
    "areaSlug": "kilcock",
    "areaName": "Kilcock",
    "county": "Kildare"
  },
  {
    "areaSlug": "kilcoole",
    "areaName": "Kilcoole",
    "county": "Wicklow"
  },
  {
    "areaSlug": "kilcooly",
    "areaName": "Kilcooly",
    "county": "South Tipperary"
  },
  {
    "areaSlug": "kilcullen",
    "areaName": "Kilcullen",
    "county": "Kildare"
  },
  {
    "areaSlug": "kildalkey",
    "areaName": "Kildalkey",
    "county": "Meath"
  },
  {
    "areaSlug": "kildangan",
    "areaName": "Kildangan",
    "county": "Kildare"
  },
  {
    "areaSlug": "kildare",
    "areaName": "Kildare",
    "county": "Kildare"
  },
  {
    "areaSlug": "kilkea",
    "areaName": "Kilkea",
    "county": "Kildare"
  },
  {
    "areaSlug": "kill",
    "areaName": "Kill",
    "county": "Kildare"
  },
  {
    "areaSlug": "killaconnigan",
    "areaName": "Killaconnigan",
    "county": "Meath"
  },
  {
    "areaSlug": "killallon",
    "areaName": "Killallon",
    "county": "Meath"
  },
  {
    "areaSlug": "killary",
    "areaName": "Killary",
    "county": "Meath"
  },
  {
    "areaSlug": "killashee",
    "areaName": "Killashee",
    "county": "Kildare"
  },
  {
    "areaSlug": "killeagh",
    "areaName": "Killeagh",
    "county": "Cork"
  },
  {
    "areaSlug": "killeen",
    "areaName": "Killeen",
    "county": "Galway"
  },
  {
    "areaSlug": "killinthomas",
    "areaName": "Killinthomas",
    "county": "Kildare"
  },
  {
    "areaSlug": "killinure",
    "areaName": "Killinure",
    "county": "Wicklow"
  },
  {
    "areaSlug": "killiskey",
    "areaName": "Killiskey",
    "county": "Wicklow"
  },
  {
    "areaSlug": "killyon",
    "areaName": "Killyon",
    "county": "Offaly"
  },
  {
    "areaSlug": "kilmacanoge",
    "areaName": "Kilmacanoge",
    "county": "Wicklow"
  },
  {
    "areaSlug": "kilmainham",
    "areaName": "Kilmainham",
    "county": "Meath"
  },
  {
    "areaSlug": "kilmeage",
    "areaName": "Kilmeage",
    "county": "Kildare"
  },
  {
    "areaSlug": "kilmessan",
    "areaName": "Kilmessan",
    "county": "Meath"
  },
  {
    "areaSlug": "kilmore",
    "areaName": "Kilmore",
    "county": "Wexford"
  },
  {
    "areaSlug": "kilpatrick",
    "areaName": "Kilpatrick",
    "county": "Kildare"
  },
  {
    "areaSlug": "kilpipe",
    "areaName": "Kilpipe",
    "county": "Wicklow"
  },
  {
    "areaSlug": "kilrainy",
    "areaName": "Kilrainy",
    "county": "Kildare"
  },
  {
    "areaSlug": "kilrush",
    "areaName": "Kilrush",
    "county": "Kildare"
  },
  {
    "areaSlug": "kilsallaghan",
    "areaName": "Kilsallaghan",
    "county": "Fingal"
  },
  {
    "areaSlug": "kilskeer",
    "areaName": "Kilskeer",
    "county": "Meath"
  },
  {
    "areaSlug": "kilteel",
    "areaName": "Kilteel",
    "county": "Kildare"
  },
  {
    "areaSlug": "kimmage",
    "areaName": "Kimmage",
    "county": "Dublin City"
  },
  {
    "areaSlug": "kinsaley",
    "areaName": "Kinsaley",
    "county": "Fingal"
  },
  {
    "areaSlug": "knocklough",
    "areaName": "Knocklough",
    "county": "Meath"
  },
  {
    "areaSlug": "knocknacarragh",
    "areaName": "Knocknacarragh",
    "county": "Galway City"
  },
  {
    "areaSlug": "knocknaheeny",
    "areaName": "Knocknaheeny",
    "county": "Cork City"
  },
  {
    "areaSlug": "knockrath",
    "areaName": "Knockrath",
    "county": "Wicklow"
  },
  {
    "areaSlug": "knockrea",
    "areaName": "Knockrea",
    "county": "Cork City"
  },
  {
    "areaSlug": "kylemore",
    "areaName": "Kylemore",
    "county": "Galway"
  },
  {
    "areaSlug": "lackagh",
    "areaName": "Lackagh",
    "county": "Kildare"
  },
  {
    "areaSlug": "lackan",
    "areaName": "Lackan",
    "county": "Wicklow"
  },
  {
    "areaSlug": "ladytown",
    "areaName": "Ladytown",
    "county": "Kildare"
  },
  {
    "areaSlug": "laracor",
    "areaName": "Laracor",
    "county": "Meath"
  },
  {
    "areaSlug": "leixlip",
    "areaName": "Leixlip",
    "county": "Kildare"
  },
  {
    "areaSlug": "lough-atalia",
    "areaName": "Lough Atalia",
    "county": "Galway City"
  },
  {
    "areaSlug": "loughan",
    "areaName": "Loughan",
    "county": "Meath"
  },
  {
    "areaSlug": "lucan",
    "areaName": "Lucan",
    "county": "Fingal"
  },
  {
    "areaSlug": "lucan-esker",
    "areaName": "Lucan Esker",
    "county": "South Dublin"
  },
  {
    "areaSlug": "lucan-heights",
    "areaName": "Lucan Heights",
    "county": "South Dublin"
  },
  {
    "areaSlug": "lucan-st.-helens",
    "areaName": "Lucan St. Helens",
    "county": "South Dublin"
  },
  {
    "areaSlug": "lugglass",
    "areaName": "Lugglass",
    "county": "Wicklow"
  },
  {
    "areaSlug": "lullymore",
    "areaName": "Lullymore",
    "county": "Kildare"
  },
  {
    "areaSlug": "lusk",
    "areaName": "Lusk",
    "county": "Fingal"
  },
  {
    "areaSlug": "mahon",
    "areaName": "Mahon",
    "county": "Cork City"
  },
  {
    "areaSlug": "malahide",
    "areaName": "Malahide",
    "county": "Fingal"
  },
  {
    "areaSlug": "mansion-house",
    "areaName": "Mansion House",
    "county": "Dublin City"
  },
  {
    "areaSlug": "maperath",
    "areaName": "Maperath",
    "county": "Meath"
  },
  {
    "areaSlug": "mardyke",
    "areaName": "Mardyke",
    "county": "Cork City"
  },
  {
    "areaSlug": "martry",
    "areaName": "Martry",
    "county": "Meath"
  },
  {
    "areaSlug": "matehy",
    "areaName": "Matehy",
    "county": "Cork City"
  },
  {
    "areaSlug": "mayfield",
    "areaName": "Mayfield",
    "county": "Cork City"
  },
  {
    "areaSlug": "maynooth",
    "areaName": "Maynooth",
    "county": "Kildare"
  },
  {
    "areaSlug": "mellifont",
    "areaName": "Mellifont",
    "county": "Meath"
  },
  {
    "areaSlug": "menlough",
    "areaName": "Menlough",
    "county": "Galway City"
  },
  {
    "areaSlug": "merchants-quay",
    "areaName": "Merchants Quay",
    "county": "Dublin City"
  },
  {
    "areaSlug": "mervue",
    "areaName": "Mervue",
    "county": "Galway City"
  },
  {
    "areaSlug": "monasterevin",
    "areaName": "Monasterevin",
    "county": "Kildare"
  },
  {
    "areaSlug": "money",
    "areaName": "Money",
    "county": "Wicklow"
  },
  {
    "areaSlug": "moneystown",
    "areaName": "Moneystown",
    "county": "Wicklow"
  },
  {
    "areaSlug": "montenotte",
    "areaName": "Montenotte",
    "county": "Cork City"
  },
  {
    "areaSlug": "moone",
    "areaName": "Moone",
    "county": "Kildare"
  },
  {
    "areaSlug": "morristownbiller",
    "areaName": "Morristownbiller",
    "county": "Kildare"
  },
  {
    "areaSlug": "mountjoy",
    "areaName": "Mountjoy",
    "county": "Dublin City"
  },
  {
    "areaSlug": "moybolgue",
    "areaName": "Moybolgue",
    "county": "Meath"
  },
  {
    "areaSlug": "moylagh",
    "areaName": "Moylagh",
    "county": "Meath"
  },
  {
    "areaSlug": "moynalty",
    "areaName": "Moynalty",
    "county": "Meath"
  },
  {
    "areaSlug": "murroogh",
    "areaName": "Murroogh",
    "county": "Galway City"
  },
  {
    "areaSlug": "naas",
    "areaName": "Naas",
    "county": "Kildare"
  },
  {
    "areaSlug": "narraghmore",
    "areaName": "Narraghmore",
    "county": "Kildare"
  },
  {
    "areaSlug": "navan",
    "areaName": "Navan",
    "county": "Meath"
  },
  {
    "areaSlug": "newcastle",
    "areaName": "Newcastle",
    "county": "Galway City"
  },
  {
    "areaSlug": "newtown",
    "areaName": "Newtown",
    "county": "Kildare"
  },
  {
    "areaSlug": "nobber",
    "areaName": "Nobber",
    "county": "Meath"
  },
  {
    "areaSlug": "north-city",
    "areaName": "North City",
    "county": "Dublin City"
  },
  {
    "areaSlug": "north-dock",
    "areaName": "North Dock",
    "county": "Dublin City"
  },
  {
    "areaSlug": "nuns-island",
    "areaName": "Nuns Island",
    "county": "Galway City"
  },
  {
    "areaSlug": "nurney",
    "areaName": "Nurney",
    "county": "Kildare"
  },
  {
    "areaSlug": "oldcastle",
    "areaName": "Oldcastle",
    "county": "Meath"
  },
  {
    "areaSlug": "oldconnell",
    "areaName": "Oldconnell",
    "county": "Kildare"
  },
  {
    "areaSlug": "oldtown",
    "areaName": "Oldtown",
    "county": "Wicklow"
  },
  {
    "areaSlug": "oughterard",
    "areaName": "Oughterard",
    "county": "Galway"
  },
  {
    "areaSlug": "ovens",
    "areaName": "Ovens",
    "county": "Cork City"
  },
  {
    "areaSlug": "ovoca",
    "areaName": "Ovoca",
    "county": "Wicklow"
  },
  {
    "areaSlug": "painestown",
    "areaName": "Painestown",
    "county": "Meath"
  },
  {
    "areaSlug": "palmerston",
    "areaName": "Palmerston",
    "county": "South Dublin"
  },
  {
    "areaSlug": "palmerston-village",
    "areaName": "Palmerston Village",
    "county": "South Dublin"
  },
  {
    "areaSlug": "pembroke",
    "areaName": "Pembroke",
    "county": "Dublin City"
  },
  {
    "areaSlug": "phoenix-park",
    "areaName": "Phoenix Park",
    "county": "Dublin City"
  },
  {
    "areaSlug": "pollardstown",
    "areaName": "Pollardstown",
    "county": "Kildare"
  },
  {
    "areaSlug": "portmarnock",
    "areaName": "Portmarnock",
    "county": "Fingal"
  },
  {
    "areaSlug": "posseckstown",
    "areaName": "Posseckstown",
    "county": "Meath"
  },
  {
    "areaSlug": "pouladuff",
    "areaName": "Pouladuff",
    "county": "Cork City"
  },
  {
    "areaSlug": "powerscourt",
    "areaName": "Powerscourt",
    "county": "Wicklow"
  },
  {
    "areaSlug": "priorswood",
    "areaName": "Priorswood",
    "county": "Dublin City"
  },
  {
    "areaSlug": "quinsborough",
    "areaName": "Quinsborough",
    "county": "Kildare"
  },
  {
    "areaSlug": "raheny-foxfield",
    "areaName": "Raheny Foxfield",
    "county": "Dublin City"
  },
  {
    "areaSlug": "raheny-greendale",
    "areaName": "Raheny Greendale",
    "county": "Dublin City"
  },
  {
    "areaSlug": "raheny-st.-assam",
    "areaName": "Raheny St. Assam",
    "county": "Dublin City"
  },
  {
    "areaSlug": "rahinstown",
    "areaName": "Rahinstown",
    "county": "Meath"
  },
  {
    "areaSlug": "rahoon",
    "areaName": "Rahoon",
    "county": "Galway City"
  },
  {
    "areaSlug": "rath",
    "areaName": "Rath",
    "county": "Clare"
  },
  {
    "areaSlug": "rathangan",
    "areaName": "Rathangan",
    "county": "Kildare"
  },
  {
    "areaSlug": "rathcoole",
    "areaName": "Rathcoole",
    "county": "Kilkenny"
  },
  {
    "areaSlug": "rathcooney",
    "areaName": "Rathcooney",
    "county": "Cork City"
  },
  {
    "areaSlug": "rathdangan",
    "areaName": "Rathdangan",
    "county": "Wicklow"
  },
  {
    "areaSlug": "rathdrum",
    "areaName": "Rathdrum",
    "county": "Wicklow"
  },
  {
    "areaSlug": "rathernan",
    "areaName": "Rathernan",
    "county": "Kildare"
  },
  {
    "areaSlug": "rathfarnham",
    "areaName": "Rathfarnham",
    "county": "Dublin City"
  },
  {
    "areaSlug": "rathfarnham-ballyroan",
    "areaName": "Rathfarnham Ballyroan",
    "county": "South Dublin"
  },
  {
    "areaSlug": "rathfarnham-butterfield",
    "areaName": "Rathfarnham Butterfield",
    "county": "South Dublin"
  },
  {
    "areaSlug": "rathfarnham-hermitage",
    "areaName": "Rathfarnham Hermitage",
    "county": "South Dublin"
  },
  {
    "areaSlug": "rathfarnham-st.-enda's",
    "areaName": "Rathfarnham St. Enda's",
    "county": "South Dublin"
  },
  {
    "areaSlug": "rathfarnham-village",
    "areaName": "Rathfarnham Village",
    "county": "South Dublin"
  },
  {
    "areaSlug": "rathfeigh",
    "areaName": "Rathfeigh",
    "county": "Meath"
  },
  {
    "areaSlug": "rathkenny",
    "areaName": "Rathkenny",
    "county": "Meath"
  },
  {
    "areaSlug": "rathmichael-(bray)",
    "areaName": "Rathmichael (bray)",
    "county": "Wicklow"
  },
  {
    "areaSlug": "rathmines",
    "areaName": "Rathmines",
    "county": "Dublin City"
  },
  {
    "areaSlug": "rathmolyon",
    "areaName": "Rathmolyon",
    "county": "Meath"
  },
  {
    "areaSlug": "rathmore",
    "areaName": "Rathmore",
    "county": "Kerry"
  },
  {
    "areaSlug": "rathsallagh",
    "areaName": "Rathsallagh",
    "county": "Wicklow"
  },
  {
    "areaSlug": "ratoath",
    "areaName": "Ratoath",
    "county": "Meath"
  },
  {
    "areaSlug": "renmore",
    "areaName": "Renmore",
    "county": "Galway City"
  },
  {
    "areaSlug": "riverstown",
    "areaName": "Riverstown",
    "county": "Cork"
  },
  {
    "areaSlug": "robertstown",
    "areaName": "Robertstown",
    "county": "Kildare"
  },
  {
    "areaSlug": "rockbarton",
    "areaName": "Rockbarton",
    "county": "Galway City"
  },
  {
    "areaSlug": "rodanstown",
    "areaName": "Rodanstown",
    "county": "Meath"
  },
  {
    "areaSlug": "rotunda",
    "areaName": "Rotunda",
    "county": "Dublin City"
  },
  {
    "areaSlug": "royal-exchange",
    "areaName": "Royal Exchange",
    "county": "Dublin City"
  },
  {
    "areaSlug": "rush",
    "areaName": "Rush",
    "county": "Fingal"
  },
  {
    "areaSlug": "saggart",
    "areaName": "Saggart",
    "county": "South Dublin"
  },
  {
    "areaSlug": "saint-kevin's",
    "areaName": "Saint Kevin's",
    "county": "Dublin City"
  },
  {
    "areaSlug": "salthill",
    "areaName": "Salthill",
    "county": "Galway City"
  },
  {
    "areaSlug": "shanakiel",
    "areaName": "Shanakiel",
    "county": "Cork City"
  },
  {
    "areaSlug": "shandon",
    "areaName": "Shandon",
    "county": "Cork City"
  },
  {
    "areaSlug": "shantalla",
    "areaName": "Shantalla",
    "county": "Galway City"
  },
  {
    "areaSlug": "shillelagh",
    "areaName": "Shillelagh",
    "county": "Wicklow"
  },
  {
    "areaSlug": "skerries",
    "areaName": "Skerries",
    "county": "Kildare"
  },
  {
    "areaSlug": "skreen",
    "areaName": "Skreen",
    "county": "Sligo"
  },
  {
    "areaSlug": "slane",
    "areaName": "Slane",
    "county": "Meath"
  },
  {
    "areaSlug": "south-dock",
    "areaName": "South Dock",
    "county": "Dublin City"
  },
  {
    "areaSlug": "south-gate",
    "areaName": "South Gate",
    "county": "Cork City"
  },
  {
    "areaSlug": "st.-mary's",
    "areaName": "St. Mary's",
    "county": "Wexford"
  },
  {
    "areaSlug": "st.-mary's-(east)",
    "areaName": "St. Mary's (east)",
    "county": "Cork City"
  },
  {
    "areaSlug": "st.-mary's-(west)",
    "areaName": "St. Mary's (west)",
    "county": "Cork City"
  },
  {
    "areaSlug": "st.-nicholas",
    "areaName": "St. Nicholas",
    "county": "Galway City"
  },
  {
    "areaSlug": "st.-patrick's",
    "areaName": "St. Patrick's",
    "county": "Cork City"
  },
  {
    "areaSlug": "stackallan",
    "areaName": "Stackallan",
    "county": "Meath"
  },
  {
    "areaSlug": "staholmog",
    "areaName": "Staholmog",
    "county": "Meath"
  },
  {
    "areaSlug": "stamullin",
    "areaName": "Stamullin",
    "county": "Meath"
  },
  {
    "areaSlug": "stonefield",
    "areaName": "Stonefield",
    "county": "Meath"
  },
  {
    "areaSlug": "straffan",
    "areaName": "Straffan",
    "county": "Kildare"
  },
  {
    "areaSlug": "stratford",
    "areaName": "Stratford",
    "county": "Wicklow"
  },
  {
    "areaSlug": "summerhill",
    "areaName": "Summerhill",
    "county": "Meath"
  },
  {
    "areaSlug": "sunday's-well",
    "areaName": "Sunday's Well",
    "county": "Cork City"
  },
  {
    "areaSlug": "sutton",
    "areaName": "Sutton",
    "county": "Fingal"
  },
  {
    "areaSlug": "swords-forrest",
    "areaName": "Swords Forrest",
    "county": "Fingal"
  },
  {
    "areaSlug": "swords-glasmore",
    "areaName": "Swords Glasmore",
    "county": "Fingal"
  },
  {
    "areaSlug": "swords-lissenhall",
    "areaName": "Swords Lissenhall",
    "county": "Fingal"
  },
  {
    "areaSlug": "swords-seatown",
    "areaName": "Swords Seatown",
    "county": "Fingal"
  },
  {
    "areaSlug": "swords-village",
    "areaName": "Swords Village",
    "county": "Fingal"
  },
  {
    "areaSlug": "talbotstown",
    "areaName": "Talbotstown",
    "county": "Wicklow"
  },
  {
    "areaSlug": "tallaght-avonbeg",
    "areaName": "Tallaght Avonbeg",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-belgard",
    "areaName": "Tallaght Belgard",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-fettercairn",
    "areaName": "Tallaght Fettercairn",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-glenview",
    "areaName": "Tallaght Glenview",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-jobstown",
    "areaName": "Tallaght Jobstown",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-killinardan",
    "areaName": "Tallaght Killinardan",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-kilnamanagh",
    "areaName": "Tallaght Kilnamanagh",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-kiltipper",
    "areaName": "Tallaght Kiltipper",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-kingswood",
    "areaName": "Tallaght Kingswood",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-millbrook",
    "areaName": "Tallaght Millbrook",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-oldbawn",
    "areaName": "Tallaght Oldbawn",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-springfield",
    "areaName": "Tallaght Springfield",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tallaght-tymon",
    "areaName": "Tallaght Tymon",
    "county": "South Dublin"
  },
  {
    "areaSlug": "tara",
    "areaName": "Tara",
    "county": "Meath"
  },
  {
    "areaSlug": "taylors-hill",
    "areaName": "Taylors Hill",
    "county": "Galway City"
  },
  {
    "areaSlug": "teltown",
    "areaName": "Teltown",
    "county": "Meath"
  },
  {
    "areaSlug": "templeogue-cypress",
    "areaName": "Templeogue Cypress",
    "county": "South Dublin"
  },
  {
    "areaSlug": "templeogue-kimmage-manor",
    "areaName": "Templeogue Kimmage Manor",
    "county": "South Dublin"
  },
  {
    "areaSlug": "templeogue-limekiln",
    "areaName": "Templeogue Limekiln",
    "county": "South Dublin"
  },
  {
    "areaSlug": "templeogue-orwell",
    "areaName": "Templeogue Orwell",
    "county": "South Dublin"
  },
  {
    "areaSlug": "templeogue-osprey",
    "areaName": "Templeogue Osprey",
    "county": "South Dublin"
  },
  {
    "areaSlug": "templeogue-village",
    "areaName": "Templeogue Village",
    "county": "South Dublin"
  },
  {
    "areaSlug": "terenure",
    "areaName": "Terenure",
    "county": "Dublin City"
  },
  {
    "areaSlug": "terenure-cherryfield",
    "areaName": "Terenure Cherryfield",
    "county": "South Dublin"
  },
  {
    "areaSlug": "terenure-greentrees",
    "areaName": "Terenure Greentrees",
    "county": "South Dublin"
  },
  {
    "areaSlug": "terenure-st.-james",
    "areaName": "Terenure St. James",
    "county": "South Dublin"
  },
  {
    "areaSlug": "the-glen",
    "areaName": "The Glen",
    "county": "Cork City"
  },
  {
    "areaSlug": "the-grange",
    "areaName": "The Grange",
    "county": "Wicklow"
  },
  {
    "areaSlug": "the-lough",
    "areaName": "The Lough",
    "county": "Cork City"
  },
  {
    "areaSlug": "the-ward",
    "areaName": "The Ward",
    "county": "Fingal"
  },
  {
    "areaSlug": "thomastown",
    "areaName": "Thomastown",
    "county": "Kilkenny"
  },
  {
    "areaSlug": "timahoe",
    "areaName": "Timahoe",
    "county": "Kildare"
  },
  {
    "areaSlug": "tinahely",
    "areaName": "Tinahely",
    "county": "Wicklow"
  },
  {
    "areaSlug": "tivoli",
    "areaName": "Tivoli",
    "county": "Cork City"
  },
  {
    "areaSlug": "tober",
    "areaName": "Tober",
    "county": "Wicklow"
  },
  {
    "areaSlug": "togher",
    "areaName": "Togher",
    "county": "Wicklow"
  },
  {
    "areaSlug": "tramore",
    "areaName": "Tramore",
    "county": "Cork City"
  },
  {
    "areaSlug": "trim",
    "areaName": "Trim",
    "county": "Meath"
  },
  {
    "areaSlug": "trohanny",
    "areaName": "Trohanny",
    "county": "Meath"
  },
  {
    "areaSlug": "trooperstown",
    "areaName": "Trooperstown",
    "county": "Wicklow"
  },
  {
    "areaSlug": "tuckmill",
    "areaName": "Tuckmill",
    "county": "Wicklow"
  },
  {
    "areaSlug": "turnapin",
    "areaName": "Turnapin",
    "county": "Fingal"
  },
  {
    "areaSlug": "turner's-cross",
    "areaName": "Turner's Cross",
    "county": "Cork City"
  },
  {
    "areaSlug": "ushers",
    "areaName": "Ushers",
    "county": "Dublin City"
  },
  {
    "areaSlug": "usk",
    "areaName": "Usk",
    "county": "Kildare"
  },
  {
    "areaSlug": "walkinstown",
    "areaName": "Walkinstown",
    "county": "Dublin City"
  },
  {
    "areaSlug": "wellpark",
    "areaName": "Wellpark",
    "county": "Galway City"
  },
  {
    "areaSlug": "whitechurch",
    "areaName": "Whitechurch",
    "county": "Cork City"
  },
  {
    "areaSlug": "whitehall",
    "areaName": "Whitehall",
    "county": "Dublin City"
  },
  {
    "areaSlug": "wicklow",
    "areaName": "Wicklow",
    "county": "Wicklow"
  },
  {
    "areaSlug": "windmill-cross",
    "areaName": "Windmill Cross",
    "county": "Kildare"
  },
  {
    "areaSlug": "wood-quay",
    "areaName": "Wood Quay",
    "county": "Dublin City"
  }
];

export function getAllAreas(): AreaInfo[] {
  return allAreas;
}

const neighborhoodMap = { getAllAreas };
export default neighborhoodMap;
